import AccountsList from "./accounts-list";
export default AccountsList;